import React, { useState, useEffect } from "react";
import UserList from "@/components/UserList";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import Loading from "@/components/Loading";
import { Alert } from "react-bootstrap";
import { GiCrossMark } from "react-icons/gi";
import { showToast } from "@/api/notification";

const UserManager: React.FC = () => {
  const { getApi, deleteApi, data, error, removeError, loading } =
    useGeneralApiCall();
  const [users, setUsers] = useState<any[]>([]);

  const handleDeleteUser = (id: string) => {
    deleteApi("api/auth/v1/user/delete", id).then(() => {
      showToast({ message: "User Delete Successfully", type: "success" });
      getApi("api/auth/v1/user/list/");
    });
  };

  useEffect(() => {
    getApi("api/auth/v1/user/list/");
  }, []);

  useEffect(() => {
    setUsers(data && data.data);
  }, [data]);

  return (
    <div className="container mt-4">
      {loading ? (
        <Loading />
      ) : error ? (
        <Alert variant="danger">
          {" "}
          <div className="d-flex justify-content-between  align-items-center">
            <p>{error}</p>

            <GiCrossMark onClick={removeError} className="cursor-pointer " />
          </div>
        </Alert>
      ) : Array.isArray(users) && users.length <= 0 ? (
        <Alert variant="primary">User Data is Not present </Alert>
      ) : (
        <UserList users={users} handleDeleteUser={handleDeleteUser} />
      )}
    </div>
  );
};

export default UserManager;
